import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
import "firebase/analytics";
import "firebase/functions";

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyDedLBCTBGSQrHvuS6bAywaeseeuzuOWaw",
  authDomain: "plusminus-b973d.firebaseapp.com",
  databaseURL: "https://plusminus-b973d.firebaseio.com",
  projectId: "plusminus-b973d",
  storageBucket: "plusminus-b973d.appspot.com",
  messagingSenderId: "636706614499",
  appId: "1:636706614499:web:52808df4932d92aa6169d6",
  measurementId: "G-96VLXVEJZC",
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

export const fire_auth = firebase.auth();
export const fire_auth_provider = firebase.auth;

export const fire_functions = firebase.app().functions("asia-south1");

export const fire_store = firebase.firestore();
export const fire_storage = firebase.storage();
export const firestore_fieldvalue = firebase.firestore.FieldValue;
